import AppModel from './model';

import config from './../config';
import {extend} from './../zviz2/zviz/functions';
import ModelCollection from './../zviz2/zviz/modelcollection'

class UrlHash extends AppModel{

    constructor(name=null, settings={}){
        
        settings = extend(settings, {
            endpoint: config.root + 'hash',
            method: 'POST',
            listeners: [ ]
        });
        
        super(name, settings);

        this.cache = new Map();
        this.input = false;

    }

    save(stateJSON){
        this.input = {
            'type': 'save',
            'state': stateJSON
        };

        this.update();
    }

    load(hash){

        let success = this.checkParams(hash);
        if(success){
            return;
        }

        this.input = {
            'select': [
                ['urlvalue'], ['shortcut']
            ],
            
            'filter': super.processFilterOld({
                'application_name': 'eval',
                'shortcut': hash
            }),

            'table': 'urlhash',
            'multiple': false,
            'type': 'load'
        }

        this.update();
    }

    getSelect(){
        return this.input;
    }

    checkParams(hash){
        let state = {};
        if(hash.indexOf('=') != -1){
            let params = hash.split('&');
            for(let p of params){
                let values = p.split('=');
                if(values.length == 2){
                    this.setParam(state, decodeURIComponent(values[0]), decodeURIComponent(values[1]));
                }
            }
        }
        if(Object.keys(state).length > 0){
            let data = {
                type: 'load',
                hash: hash,
                state: JSON.stringify(state),
                status: 'success'
            };
            this.setData(data, null);
            return true;
        }
        return false;
    }

    setParam(state, key, value){
        if(key == 'tc_symbol'){
            state['filter'] = {'tc_symbol': value.replace(/-/g, '/')};
            state['source'] = 'eval';
        }else if(key == 'eval_id'){
            state['filter'] = {'eval_id': value};
            state['source'] = 'eval';
            state['view'] = 'list';
        }else if(key == 'll_id'){
            state['filter'] = {'ll_id': value};
            state['source'] = 'll';
            state['view'] = 'list';
        }else if(key == 'gp_id'){
            state['filter'] = {'gp_id': value};
            state['source'] = 'gp';
            state['view'] = 'list';
        }else if(key == 'rec_id'){
            state['filter'] = {'rec_id': value};
            state['source'] = 'rec';
            state['view'] = 'list';
        }else if(key == 'country_iso'){
            if(typeof value != 'string'){
                return;
            }
            value = value.toUpperCase();
            
            if(! state['filter']){
                state['filter'] = {};
            }
            if(value.length == 2){
                state['filter'] = {'country_iso2': value};
            }else{
                state['filter'] = {'country_iso3': value};
            }
        }else if(key == 'year'){
            if(typeof value != 'string'){
                return;
            }
            let years = value.split('-');
            let yearsClean = [];
            for(let i = 0; i < years.length; i++){
                let y = parseInt(years[i], 10);
                if(y){
                    yearsClean.push(y);
                }
            }
            if(yearsClean.length > 0){
                years = [];
                for(let y = Math.min(...yearsClean); y <= Math.max(...yearsClean); y++){
                    years.push(y);
                }
                if(! state['filter']){
                    state['filter'] = {};
                }
                state['filter']['year'] = years;
            }
        }else if(key == 'source'){
            state['source'] = value;
        }else if(key == 'view'){
            state['view'] = (value=='list')? 'list': 'regional';
        }else if(key == 'unit'){
            if(typeof value != 'string'){
                return;
            }
            let units = value.split(',');
            if(units.length > 0){
                if(! state['filter']){
                    state['filter'] = {};
                }
                state['filter']['administrative_unit'] = units;
            }
        }
    }

    getDataFromResponse(input){
        input = super.getDataFromResponse(input);
        if(input == null){
            return null;
        }

        let data = {
            status: 'error'
        };

        try{
            if(input['type'] == 'save'){
                data.type = 'save';
                data.hash = input['shortcut'];
                data.state = input['urlvalue']; //.replace(/\"/g, /"/);
                data.status = 'success';
            }else{
                data.type = 'load';
                data.hash = input['results'][0]['shortcut'];
                data.state = input['results'][0]['urlvalue'];
                data.status = 'success';
            }

        }catch(e){
            console.warn('Hash url data not well formatted');
        }
        return data;
    }


}

ModelCollection.setModelClass('urlhash', UrlHash);

export default UrlHash;